export default {
  methods: {
    // 缩略图列表 两行半显示点点
    twoHalfTextFilter(str) {
      if (str && str.length > 145) {
        return str.substr(0, 145) + '…'
      } else {
        return str
      }
    },
    thousandsSeparator(num) {
      num = parseInt(num).toLocaleString() // 千位分隔符
      return num
    },
    replaceKeyWord(str, key) {
      // console.log({ str, key }) // eslint-disable-line no-console
      if (!str || !key || key.trim() === '') {
        return str
      }
      // let arr = key.split('')
      // arr.forEach(el => {
      str = str.split(key).join(`<i class="search-key">${key}</i>`)
      // })
      return str
    }
  }
}
